"use client"

import { AuthMode } from "@/components/auth/auth-mode"
import { UnifiedAuthPage } from "@/components/auth/unified-auth-page"

interface PageProps {
  searchParams?: Promise<Record<string, string | string[] | undefined>>
}

export default function SignInPage({ searchParams }: PageProps) {
  return (
    <UnifiedAuthPage
      searchParams={searchParams}
      initialAuthMode={AuthMode.SignIn}
    />
  )
}
